module.exports = __webpack_public_path__ + "static/media/trainingIcon.c51b2269.png";